import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { AutCambioPrecioContent } from './components/AutCambioPrecioContent';

export default function AutCambioPrecio() {
    return (
        <>
            <MainContent
                component={<AutCambioPrecioContent />}
                titulo='Autorización Cambio de precio'	
                noBackground
                tableMaxWidth
            />
        </>
    );

};
